import '../styles/basic.css';
import gooze_on from 'url:../assets/ads/AD-gooze-on.gif';
import gooze_off from 'url:../assets/ads/AD-gooze-off.png';
import { Plzma } from './cursor/plz/Plzma';

export enum Ad
{
    Gooze
}

export function AdBanner (props: {ad : Ad, onClick ?: any, animated ?: boolean})
{
    const animated = props.animated !== undefined ? props.animated : true;

    let onImage : string = '';
    let offImage : string = '';
    switch (props.ad)
    {
        case Ad.Gooze:
            onImage = gooze_on;
            offImage = gooze_off;
            break;
    }

    return <Plzma
        onState={ <img src={onImage} className='adbanner' onClick={props.onClick} /> }
        offState={ <img src={offImage} className='adbanner' onClick={props.onClick} /> }
        startOn={animated}>
    </Plzma>
}